import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { INTERFACES, metricsFor } from "../../../utils/netquality";
import styles from "../network_map.module.css";

const PERIODS = [
  { key: "day", days: 1 },
  { key: "week", days: 7 },
  { key: "month", days: 30 },
];
const CELL_SIZES = [25, 50, 100, 250];

export default function ControlsPanel({
  open, onClose, iface, setIface, metric, setMetric, days, setDays, cellM, setCellM,
  pdui, setPdui, devices, connectedOnly, setConnectedOnly, showChanges, setShowChanges,
  available, cellCount, sampleCount,
}) {
  const { t } = useTranslation();
  return (
    <div className={`${styles.controls} ${open ? styles.controlsOpen : ""}`}>
      <div className={styles.controlsTitle}>
        {t("netmap.title")}
        <button type="button" className={styles.closeButton} onClick={onClose} aria-label={t("netmap.close")}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
      <div className={styles.controlsSubtitle}>{t("netmap.subtitle")}</div>

      <div className={styles.group}>
        <div className={styles.groupLabel}>{t("netmap.interface")}</div>
        <div className={styles.chips}>
          {INTERFACES.map((key) => (
            <button
              key={key}
              type="button"
              className={`${styles.chip} ${iface === key ? styles.chipActive : ""}`}
              onClick={() => setIface(key)}
            >
              {t(`netmap.iface.${key}`)}
              {available && available[key] !== undefined && <span className={styles.chipCount}>{available[key]}</span>}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.group}>
        <div className={styles.groupLabel}>{t("netmap.metric")}</div>
        <select className={styles.select} value={metric} onChange={(e) => setMetric(e.target.value)}>
          {metricsFor(iface).map((key) => (
            <option key={key} value={key}>{t(`netmap.metrics.${key}`)}</option>
          ))}
        </select>
      </div>

      <div className={styles.group}>
        <div className={styles.groupLabel}>{t("netmap.period")}</div>
        <div className={styles.chips}>
          {PERIODS.map((p) => (
            <button
              key={p.key}
              type="button"
              className={`${styles.chip} ${days === p.days ? styles.chipActive : ""}`}
              onClick={() => setDays(p.days)}
            >
              {t(`netmap.periods.${p.key}`)}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.group}>
        <div className={styles.groupLabel}>{t("netmap.cell")}</div>
        <div className={styles.chips}>
          {CELL_SIZES.map((size) => (
            <button
              key={size}
              type="button"
              className={`${styles.chip} ${cellM === size ? styles.chipActive : ""}`}
              onClick={() => setCellM(size)}
            >
              {size} m
            </button>
          ))}
        </div>
      </div>

      <div className={styles.group}>
        <div className={styles.groupLabel}>{t("netmap.device")}</div>
        <select className={styles.select} value={pdui} onChange={(e) => setPdui(e.target.value)}>
          <option value="all">{t("netmap.allDevices")}</option>
          {(devices || []).map((d) => (
            <option key={d.id} value={String(d.id)}>{d.name}</option>
          ))}
        </select>
        <label className={styles.checkRow}>
          <input type="checkbox" checked={connectedOnly} onChange={(e) => setConnectedOnly(e.target.checked)} />
          {t("netmap.connectedOnly")}
        </label>
        <label className={styles.checkRow}>
          <input type="checkbox" checked={showChanges} onChange={(e) => setShowChanges(e.target.checked)} />
          {t("netmap.showChanges")}
        </label>
      </div>

      <div className={styles.summary}>{t("netmap.summary", { cells: cellCount, samples: sampleCount })}</div>
    </div>
  );
}
